// helpers
import { EnvConfigMap, getEnvironmentViaHostname } from '@/helpers/env';
export const getPartnerServiceBasePath = () => {
    const environment = getEnvironmentViaHostname();
    return EnvConfigMap[environment].partnerServiceBasePath;
};
export const getHostname = () => {
    const environment = getEnvironmentViaHostname();
    return EnvConfigMap[environment].clientBasePath;
};
export const getOzoneServiceBasePath = (loginType) => {
    const environment = getEnvironmentViaHostname();
    return EnvConfigMap[environment].getOzoneHostName(loginType);
};
